module.exports = __webpack_public_path__ + "static/warynski-6f8dd98f1840960fd2a6c00d63f63fc9.png";